// actions.js
import * as actionTypes from "./actionsTypes";

export const setValueModeleLoyer = (value) => ({
  type: actionTypes.SET_VALUE_ModeleLoyer,
  payload: value,
});

export const setTypeModeleLoyer = (type) => ({
  type: actionTypes.SET_TYPE_ModeleLoyer,
  payload: type,
});
export const setActifModeleLoyer = (actif) => ({
  type: actionTypes.SET_ACTIF_ModeleLoyer,
  payload: actif,
});

export const setCurrentPageModeleLoyer = (page) => ({
  type: actionTypes.SET_CURRENT_PAGE_ModeleLoyer,
  payload: page,
});

export const setOrderModeleLoyer = (order) => ({
  type: actionTypes.SET_ORDER_ModeleLoyer,
  payload: order,
});

export const setSortFieldModeleLoyer = (field) => ({
  type: actionTypes.SET_SORT_FIELD_ModeleLoyer,
  payload: field,
});
export const setCategorieModeleLoyer = (categorie) => ({
  type: actionTypes.SET_CATEGORIE_ModeleLoyer,
  payload: categorie,
});
